import { render, staticRenderFns } from "./rep-waiting-item.vue?vue&type=template&id=368e9808&"
import script from "./rep-waiting-item.vue?vue&type=script&lang=js&"
export * from "./rep-waiting-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports